import { getAuthData } from "../features/auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { IconX } from "../components/icons.jsx";
import * as React from "react";
import { fetchOpeningHistoryStats } from "../api/openingHistory.jsx";
import { fetchOpeningHistory } from "../api/openingHistory.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { IconChevronLeft } from "../components/icons.jsx";
import { IconSparkles } from "../components/icons.jsx";
import { IconClock } from "../components/icons.jsx";
import { IconTrophy } from "../components/icons.jsx";
import { _n } from "./CollectionPage.jsx";
export const Kg = "_page_8jvat_1";
export const Jg = "_header_8jvat_2";
export const Wg = "_day_8jvat_5";
export const Ig = "_tabs_8jvat_7";
export const Fg = "_active_8jvat_9";
export const Pg = "_list_8jvat_10";
export const ey = "_row_8jvat_12";
export const ty = "_modal_8jvat_13";
export const ay = "_more_8jvat_20";
export const ly = "_index_8jvat_21";
export const ny = "_thumb_8jvat_22";
export const sy = "_info_8jvat_25";
export const iy = "_nameLine_8jvat_26";
export const cy = "_mediumName_8jvat_28";
export const uy = "_longName_8jvat_29";
export const oy = "_reward_8jvat_32";
export const ry = "_message_8jvat_35";
export const dy = "_note_8jvat_39";
export const fy = "_stats_8jvat_40";
export const hy = "_backdrop_8jvat_50";
export const my = "_cardDetail_8jvat_51";
export const py = "_close_8jvat_52";
export const vy = "_cardArt_8jvat_53";
export const by = "_cardInfo_8jvat_57";
export const gy = "_cardHeading_8jvat_58";
export const yy = "_cardStats_8jvat_61";
export const _y = "_cardStatus_8jvat_66";
export const Ye = {
  page: Kg,
  header: Jg,
  day: Wg,
  tabs: Ig,
  active: Fg,
  list: Pg,
  row: ey,
  modal: ty,
  more: ay,
  index: ly,
  thumb: ny,
  info: sy,
  nameLine: iy,
  mediumName: cy,
  longName: uy,
  reward: oy,
  message: ry,
  note: dy,
  stats: fy,
  backdrop: hy,
  cardDetail: my,
  close: py,
  cardArt: vy,
  cardInfo: by,
  cardHeading: gy,
  cardStats: yy,
  cardStatus: _y
};
export const jy = new Intl.DateTimeFormat("ru-RU", {
  day: "numeric",
  month: "long",
  timeZone: "Europe/Moscow"
});
export const xy = new Intl.DateTimeFormat("ru-RU", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "Europe/Moscow"
});
export const dm = new Intl.DateTimeFormat("ru-RU", {
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Moscow"
});
export const Sy = u => new Intl.DateTimeFormat("sv-SE", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  timeZone: "Europe/Moscow"
}).format(new Date(u));
export const Al = u => u ? `/${u.replace(/^\/+/, "")}` : null;
export const wy = u => u.length > 23 ? Ye.longName : u.length > 14 ? Ye.mediumName : "";
export function OpeningHistoryPage({
  onBack: u
}) {
  const [o, m] = React.useState([]),
    [r, g] = React.useState(null),
    [j, B] = React.useState(null),
    [U, N] = React.useState(!0),
    [y, X] = React.useState(!1),
    [M, R] = React.useState(null),
    [H, Y] = React.useState(!0),
    [P, W] = React.useState(!1),
    [ee, ie] = React.useState(""),
    [w, I] = React.useState(null),
    [ne, oe] = React.useState("rolls"),
    T = React.useRef(null),
    D = React.useRef(!1),
    le = React.useRef(void 0),
    te = React.useRef(null),
    Z = window.Telegram?.WebApp?.BackButton,
    V = React.useCallback(async O => {
      const L = getAuthData();
      if (!L) {
        N(!1), X(!0);
        return;
      }
      N(!0), X(!1);
      try {
        const se = await fetchOpeningHistoryStats(L, O);
        O?.aborted || B(se.stats);
      } catch {
        O?.aborted || X(!0);
      } finally {
        O?.aborted || N(!1);
      }
    }, []),
    ae = React.useCallback(async (O = 0, L) => {
      const se = getAuthData();
      if (!se) {
        Y(!1), N(!1), X(!0), ie("Откройте историю внутри Telegram.");
        return;
      }
      if (!(O && D.current)) {
        O && (D.current = !0), O ? W(!0) : Y(!0);
        try {
          const C = await fetchOpeningHistory(se, O, O ? le.current : void 0, O ? te.current : null, L);
          if (L?.aborted) return;
          le.current = C.recorded, te.current = C.nextCursor, m(f => {
            if (!O) return C.cards;
            const h = new Set(f.map(p => p.id));
            return [...f, ...C.cards.filter(p => !h.has(p.id))];
          }), g(C.total), R(C.nextOffset), ie(""), O || V(L);
        } catch {
          L?.aborted || (ie("Не удалось загрузить историю. Попробуйте ещё раз."), O || (N(!1), X(!0)));
        } finally {
          O && (D.current = !1), L?.aborted || (Y(!1), W(!1));
        }
      }
    }, [V]);
  React.useEffect(() => {
    const O = new AbortController();
    return window.scrollTo(0, 0), ae(0, O.signal), () => O.abort();
  }, [ae]), React.useEffect(() => {
    const O = T.current;
    if (ne !== "rolls" || M === null || P || ee || !O || typeof IntersectionObserver > "u") return;
    const L = new IntersectionObserver(se => {
      se[0]?.isIntersecting && ae(M);
    }, {
      rootMargin: "300px"
    });
    return L.observe(O), () => L.disconnect();
  }, [ne, M, P, ee, ae]), React.useEffect(() => {
    if (!Z) return;
    const O = () => w ? I(null) : u();
    return Z.show(), Z.onClick(O), () => {
      Z.offClick(O), Z.hide();
    };
  }, [Z, u, w]);
  const Te = j?.rarities ?? {},
    je = w ? [w.points != null ? `+${w.points.toLocaleString("ru-RU")} PTS` : null, w.gems != null ? `+${w.gems} 💎` : null].filter(Boolean).join(" · ") : "";
  let k = "";
  return jsxRuntime.jsxs("section", {
    className: Ye.page,
    "aria-labelledby": "opening-history-title",
    children: [jsxRuntime.jsxs("header", {
      className: Ye.header,
      children: [jsxRuntime.jsx("button", {
            className: "mc-icon-button",
        type: "button",
        onClick: u,
        "aria-label": "Назад к профилю",
        children: jsxRuntime.jsx(IconChevronLeft, {})
      }), jsxRuntime.jsx("h1", {
        id: "opening-history-title",
        children: "История открытий"
      })]
    }), jsxRuntime.jsxs("div", {
      className: Ye.tabs,
      role: "tablist",
      "aria-label": "Раздел истории",
      children: [jsxRuntime.jsx("button", {
        type: "button",
        role: "tab",
        "aria-selected": ne === "rolls",
        className: ne === "rolls" ? Ye.active : "",
        onClick: () => oe("rolls"),
        children: "Крутки"
      }), jsxRuntime.jsx("button", {
        type: "button",
        role: "tab",
        "aria-selected": ne === "stats",
        className: ne === "stats" ? Ye.active : "",
        onClick: () => oe("stats"),
        children: "Статистика"
      })]
    }), ee && jsxRuntime.jsxs("div", {
      className: Ye.message,
      children: [ee, jsxRuntime.jsx("button", {
        type: "button",
        onClick: () => {
          ae();
        },
        children: "Повторить"
      })]
    }), H && !o.length && jsxRuntime.jsx("p", {
      className: Ye.message,
      children: "Загружаем историю…"
    }), ne === "rolls" && !H && !ee && !o.length && jsxRuntime.jsx("p", {
      className: Ye.message,
      children: r ? "Сохранившихся записей о старых открытиях нет. Новые открытия появятся здесь после обновления журнала." : "Записей об открытиях пока нет."
    }), ne === "rolls" ? jsxRuntime.jsxs("div", {
      className: Ye.list,
      children: [o.map(O => {
        const L = Sy(O.openedAt),
          se = L !== k;
        return k = L, jsxRuntime.jsxs("div", {
          children: [se && jsxRuntime.jsx("h2", {
            className: Ye.day,
            children: jy.format(new Date(O.openedAt))
          }), jsxRuntime.jsxs("button", {
            type: "button",
            className: Ye.row,
            "data-rarity": O.rarity.toLowerCase(),
            onClick: () => I(O),
            "aria-label": `Показать карту ${O.name}`,
            children: [jsxRuntime.jsx("span", {
              className: Ye.index,
              children: O.recordNumber
            }), jsxRuntime.jsx("span", {
              className: Ye.thumb,
              children: Al(O.thumbnailPath) ? jsxRuntime.jsx("img", {
                src: Al(O.thumbnailPath),
                alt: "",
                loading: "lazy"
              }) : jsxRuntime.jsx(IconSparkles, {})
            }), jsxRuntime.jsxs("span", {
              className: Ye.info,
              children: [jsxRuntime.jsxs("span", {
                className: Ye.nameLine,
                children: [jsxRuntime.jsx("strong", {
                  className: wy(O.name),
                  title: O.name,
                  children: O.name
                }), O.compensated ? jsxRuntime.jsx("em", {
                  children: "ОБМЕН"
                }) : O.legacy ? null : O.isDuplicate === !1 ? jsxRuntime.jsx("em", {
                  children: "НОВАЯ"
                }) : O.isDuplicate === !0 ? jsxRuntime.jsx("em", {
                  children: "ПОВТОР"
                }) : null]
              }), jsxRuntime.jsxs("small", {
                children: [O.universe, O.legacy ? " · старая запись" : ""]
              })]
            }), jsxRuntime.jsxs("span", {
              className: Ye.reward,
              children: [O.compensated ? jsxRuntime.jsx("b", {
                children: "↻ Награда"
              }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
                children: [jsxRuntime.jsx("b", {
                  children: O.points != null ? `+${O.points.toLocaleString("ru-RU")} PTS` : "✦"
                }), O.gems != null && jsxRuntime.jsxs("b", {
                  children: ["+", O.gems, " 💎"]
                })]
              }), jsxRuntime.jsx("small", {
                children: dm.format(new Date(O.openedAt))
              })]
            })]
          })]
        }, O.id);
      }), M !== null && jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [jsxRuntime.jsx("div", {
          ref: T,
          "aria-hidden": "true"
        }), jsxRuntime.jsx("button", {
          type: "button",
          className: Ye.more,
          disabled: P,
          onClick: () => {
            ae(M);
          },
          children: P ? "Загружаем…" : "Показать ещё"
        })]
      }), o.some(O => O.legacy) && jsxRuntime.jsx("p", {
        className: Ye.note,
        children: "Старые записи восстановлены по картам в базе. Переданные и удалённые карты могли не сохраниться в этом списке."
      })]
    }) : jsxRuntime.jsxs("div", {
      className: Ye.stats,
      children: [U && !j && jsxRuntime.jsx("p", {
        className: Ye.message,
        children: "Загружаем статистику…"
      }), y && jsxRuntime.jsxs("p", {
        className: Ye.message,
        children: ["Не удалось загрузить статистику. ", jsxRuntime.jsx("button", {
          type: "button",
          onClick: () => {
            V();
          },
          children: "Повторить"
        })]
      }), jsxRuntime.jsxs("article", {
        children: [jsxRuntime.jsx(IconClock, {}), jsxRuntime.jsx("span", {
          children: "Всего открытий"
        }), jsxRuntime.jsx("strong", {
          children: r?.toLocaleString("ru-RU") ?? "—"
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx(IconTrophy, {
          "aria-hidden": "true"
        }), jsxRuntime.jsx("span", {
          children: "PTS по записям"
        }), jsxRuntime.jsx("strong", {
          children: j?.points.toLocaleString("ru-RU") ?? "—"
        })]
      }), jsxRuntime.jsx("p", {
        children: "Редкости среди сохранённых записей"
      }), Object.entries(Te).sort((O, L) => L[1] - O[1]).map(([O, L]) => jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsxs("span", {
          children: [_n(O), " ", O]
        }), jsxRuntime.jsx("strong", {
          children: L
        })]
      }, O))]
    }), w && jsxRuntime.jsxs("div", {
      className: Ye.modal,
      "data-rarity": w.rarity.toLowerCase(),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": `Карта ${w.name}`,
      children: [jsxRuntime.jsx("button", {
        type: "button",
        className: Ye.backdrop,
        onClick: () => I(null),
        "aria-label": "Закрыть карту"
      }), jsxRuntime.jsxs("article", {
        className: Ye.cardDetail,
        children: [jsxRuntime.jsx("button", {
          type: "button",
          className: `${Ye.close} mc-icon-button`,
          onClick: () => I(null),
          "aria-label": "Закрыть",
          children: jsxRuntime.jsx(IconX, { "aria-hidden": "true" })
        }), jsxRuntime.jsx("div", {
          className: Ye.cardArt,
          children: w.mediaType === "video" && Al(w.mediaPath) ? jsxRuntime.jsx("video", {
            src: Al(w.mediaPath),
            poster: Al(w.thumbnailPath) ?? void 0,
            controls: !0,
            playsInline: !0,
            autoPlay: !0,
            loop: !0,
            "aria-label": w.name
          }) : Al(w.thumbnailPath) ? jsxRuntime.jsx("img", {
            src: Al(w.thumbnailPath),
            alt: w.name
          }) : jsxRuntime.jsx(IconSparkles, {})
        }), jsxRuntime.jsxs("div", {
          className: Ye.cardInfo,
          children: [jsxRuntime.jsxs("header", {
            className: Ye.cardHeading,
            children: [jsxRuntime.jsx("small", {
              children: w.rarity
            }), jsxRuntime.jsx("h2", {
              children: w.name
            }), jsxRuntime.jsx("p", {
              children: w.universe
            })]
          }), jsxRuntime.jsxs("div", {
            className: Ye.cardStats,
            children: [jsxRuntime.jsxs("div", {
              children: [jsxRuntime.jsx("small", {
                children: "ПОЛУЧЕНА"
              }), jsxRuntime.jsx("b", {
                children: xy.format(new Date(w.openedAt))
              })]
            }), jsxRuntime.jsxs("div", {
              children: [jsxRuntime.jsx("small", {
                children: "ВРЕМЯ"
              }), jsxRuntime.jsxs("b", {
                children: [dm.format(new Date(w.openedAt)), " МСК"]
              })]
            }), jsxRuntime.jsxs("div", {
              children: [jsxRuntime.jsx("small", {
                children: "ОТКРЫТИЕ"
              }), jsxRuntime.jsx("b", {
                children: w.compensated ? "Обмен" : w.legacy ? "Старая запись" : w.isDuplicate === !1 ? "Новая" : w.isDuplicate === !0 ? "Повтор" : "—"
              })]
            })]
          }), jsxRuntime.jsx("div", {
            className: Ye.cardStatus,
            children: w.compensated ? "↻ Повторная LIMITED: карта заменена наградой" : je ? `✦ ${je}` : "✦ Награда не сохранилась в записи"
          })]
        })]
      })]
    })]
  });
}
